import { useProgress } from '@react-three/drei';
import React, { useEffect, useRef, useState } from "react";

const styles = {
  loaderContainer: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 999999,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
    transition: 'opacity 3s cubic-bezier(0.4, 0, 0.2, 1)',
    willChange: 'opacity',
  },
  brandContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    color: '#fff',
    textAlign: 'center',
  },
  brandName: {
    fontSize: 'clamp(2.5rem, 5vw, 4rem)',
    letterSpacing: '0.5em',
    fontWeight: '300',
    margin: 0,
    fontFamily: 'serif',
    opacity: 0,
    transform: 'translateY(20px)',
    animation: 'fadeInUp 2.5s cubic-bezier(0.4, 0, 0.2, 1) forwards',
  },
  subTitle: {
    fontSize: 'clamp(1rem, 2vw, 1.4rem)',
    letterSpacing: '0.3em',
    fontWeight: '300',
    margin: '0.5rem 0 3rem',
    opacity: 0,
    transform: 'translateY(20px)',
    animation: 'fadeInUp 2.5s cubic-bezier(0.4, 0, 0.2, 1) 0.3s forwards',
  },
  progressText: {
    fontSize: 'clamp(3rem, 6vw, 5rem)',
    fontWeight: '300',
    margin: '2rem 0 0.5rem',
    fontFamily: 'serif',
    opacity: 0,
    animation: 'fadeIn 0.8s ease forwards 1s',
  },
  loadingText: {
    fontSize: 'clamp(0.8rem, 1.5vw, 1rem)',
    letterSpacing: '0.2em',
    fontWeight: '300',
    opacity: 0,
    marginTop: '1rem',
    animation: 'fadeIn 0.8s ease forwards 1.5s, pulse 1.5s ease-in-out infinite',
  }
};

// Add keyframes for animations
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes fadeInUp {
    from { 
      opacity: 0;
      transform: translateY(20px);
    }
    to { 
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
  }
`;
document.head.appendChild(styleSheet);

const Loader = ({ onLoaderFinish }) => {
  const { progress: loadingProgress } = useProgress();
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [shouldRemove, setShouldRemove] = useState(false);
  const isAnimating = useRef(false);

  useEffect(() => {
    if (loadingProgress === 100 && !isAnimating.current) {
      isAnimating.current = true;
      
      // First trigger the canvas to start rendering
      onLoaderFinish();
      
      // Small delay to ensure canvas is ready
      setTimeout(() => {
        // Then start the fade out
        setIsFadingOut(true);
        
        // Remove loader after fade out completes plus extra delay
        setTimeout(() => {
          setShouldRemove(true);
        }, 3500); // 3s fade + 0.5s extra delay
      }, 500); // Initial delay before starting fade
    }
  }, [loadingProgress, onLoaderFinish]);

  if (shouldRemove) return null;

  return (
    <div 
      style={{
        ...styles.loaderContainer,
        opacity: isFadingOut ? 0 : 1
      }}
    >
      <div style={styles.brandContainer}>
        <h1 style={styles.brandName}>OLEA BLU</h1>
        <h2 style={styles.subTitle}>HOTEL & RESORT</h2>
        <div style={styles.progressText}>{Math.round(loadingProgress)}%</div>
        <div style={styles.loadingText}>[ EXPERIENCE IS LOADING ]</div>
      </div>
    </div>
  );
};

export default Loader;